import { isBefore, toEN } from 'utils/date.util'
import { isDate, isFutureDate, validateField } from 'utils/validate.util'
import { z } from 'zod'
import { addressInit, addressSchema } from './address.type'
import { ERROR_MESSAGE, ERROR_MESSAGE_DATE_INCORRECT } from './error.type'

export const hearingCircumstancesScheme = z
  .object({
    brevDescVestigio: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    breveRelatoNoticia: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    dtApreensao: z.string().nullish(),
    dtFato: z.string().nullish(),
    localPernoite: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    notConcretaTortura: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    vestLesaoCorp: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    providenciaAdotada: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    endereco: addressSchema,
  })
  .refine((fields) => isBefore(fields.dtFato, fields.dtApreensao), {
    path: ['dtFato'],
    message: ERROR_MESSAGE_DATE_INCORRECT,
  })

export type HearingCircumstancesType = z.infer<typeof hearingCircumstancesScheme>

export const hearingCircumstancesInit: HearingCircumstancesType = {
  brevDescVestigio: '',
  breveRelatoNoticia: '',
  dtApreensao: '',
  dtFato: '',
  localPernoite: '',
  notConcretaTortura: '',
  vestLesaoCorp: '',
  providenciaAdotada: '',
  endereco: addressInit,
}
